/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Delete_Subtitle_Aria_LabelInputs */



/**
* | output |
* | --- |
* | "Delete this subtitle event" |
*
* @param {Event_Delete_Subtitle_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_delete_subtitle_aria_label = /** @type {((inputs?: Event_Delete_Subtitle_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Delete_Subtitle_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Supprimer cet evenement de sous-titre")
	if (locale === "de") return /** @type {LocalizedString} */ ("Dieses Untertitelereignis löschen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Elimina questo evento sottotitolo")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Удалить это событие субтитров")
	if (locale === "es") return /** @type {LocalizedString} */ ("Eliminar este evento de subtítulo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("删除此字幕事件")
	if (locale === "ja") return /** @type {LocalizedString} */ ("この字幕イベントを削除")
	if (locale === "hi") return /** @type {LocalizedString} */ ("इस उपशीर्षक इवेंट को हटाएँ")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Excluir este evento de legenda")
	return /** @type {LocalizedString} */ ("Delete this subtitle event")
});